import { useState } from 'react'
import { useProductPreferences } from '../../hooks/useProductPreferences'
import { preferenceIdentity } from '../../lib/productIntegration'
// compact: heart only, for the collection summary card's footer row.
export default function FavoriteButton({ fragrance, compact = false }) {
  const prefs=useProductPreferences()
  const [busy,setBusy]=useState(false)
  const [message,setMessage]=useState('')
  const subject=preferenceIdentity(fragrance)
  const active=prefs.has('favorite',subject)
  return <span className="inline-flex flex-col" onClick={event=>event.stopPropagation()}>
    <button type="button" aria-label={`${active?'Remove':'Add'} ${fragrance.name} ${active?'from':'to'} favorites`} aria-pressed={active} disabled={busy || !prefs.available} className={`min-h-11 min-w-11 rounded-lg text-gold disabled:opacity-40 ${compact?'text-base leading-none':'px-2 text-sm'}`} onClick={async()=>{
      setBusy(true);setMessage('')
      try {await prefs.set('favorite',subject,!active);setMessage(active?'Favorite removed':'Favorite saved')} catch(error){setMessage(error.message)} finally{setBusy(false)}
    }}>{active?'♥':'♡'}{!compact && <> <span className="text-xs">Favorite</span></>}</button>
    {message && <span role="status" className={compact?'sr-only':'text-xs text-cream/70'}>{message}</span>}
  </span>
}
